import { render } from "./StoriesGroupSlider.vue?vue&type=template&id=ef88f39a&scoped=true"
import script from "./StoriesGroupSlider.vue?vue&type=script&lang=js"
export * from "./StoriesGroupSlider.vue?vue&type=script&lang=js"

import "./StoriesGroupSlider.vue?vue&type=style&index=0&id=ef88f39a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef88f39a"]])

export default __exports__